import { useState, useEffect, useRef } from "react";
import { FormField } from '@prosolve/common-components-ui'
import useDataClasses from '../dataHooks/useDataClasses'
import Cookies from 'js-cookie';

export default ({
  formData,
  restrictedToOwnedClasses
}) => {
  const userId = Cookies.get('loggedInUserId') || sessionStorage.getItem('loggedInUserId');

  const { fetchClasses } = useDataClasses()

  const [loading, setLoading] = useState(true);
  const [searchVal, setSearchVal] = useState('')
  const [classes, setClasses] = useState([])

  const fetchClassesData = async () => {
    setLoading(true)
    try {
      const classesData = await fetchClasses(formData.values.accountId, formData.values.implementationId) || []
      setClasses(classesData)
    } catch (e) {
      console.log(e)
      setClasses([])
    }
    setLoading(false)
  }

  const selectorRef = useRef()

  const onDependenciesChange = (dependencyName) => {
    const updatedValues = {
      ...formData.values,
      classId: ''
    }

    if (dependencyName === 'accountId') {
      updatedValues.implementationId = ''
    }

    formData.setValues(updatedValues)
    if (selectorRef.current && selectorRef.current.clearInput) {
      selectorRef.current.clearInput()
    }
    fetchClassesData()
  }

  useEffect(() => {
    onDependenciesChange('accountId')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values.accountId])

  useEffect(() => {
    onDependenciesChange('implementationId')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values.implementationId])

  const classOptions = restrictedToOwnedClasses ?
    classes.filter(({ Attendee__c }) => Attendee__c === userId) : 
    classes

  const options = classOptions
    .filter(({ Name }) => Name.toLowerCase().indexOf(searchVal.toLowerCase()) > -1)
    .map(({ Class_ID__c, Name }) => ({ value: Class_ID__c, text: Name }))

  if (searchVal === '') {
    options.unshift({ value: '', text: '', display: 'All' })
  }

  useEffect(() => {
    if (restrictedToOwnedClasses && !loading && !formData.values.classId && classOptions && classOptions.length > 0) {
      const fullClassIdList = classOptions.map(({ Class_ID__c }) => Class_ID__c).join(',')
      formData.setValues({ ...formData.values, classId: fullClassIdList })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values.classId, classOptions, loading])

  return (
    <FormField
      ref={selectorRef}
      style={{ flex: 1 }}
      width='100%'
      fieldId='classId'
      type='search'
      label='Class'
      formData={formData}
      options={options}
      suppressAutoClearOnFocus={true}
      isLoading={loading}
      onSearch={(val) => { setSearchVal(val) }}
      placeholder='All'
      maxHeight='200px'
    />
  )
}